import React, { useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { TradingViewChart } from './TradingViewChart';
interface TerminalOverlayProps {
  onClose: () => void;
  /** TradingView interval code inherited from the inline terminal. */
  interval?: string;
}
export function TerminalOverlay({
  onClose,
  interval = '15'
}: TerminalOverlayProps) {
  const closeRef = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKeyDown);
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    closeRef.current?.focus();
    return () => {
      document.removeEventListener('keydown', onKeyDown);
      document.body.style.overflow = previousOverflow;
    };
  }, [onClose]);
  return <motion.div role="dialog" aria-modal="true" aria-label="Terminal XAU/USD en pantalla completa" initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} transition={{
    duration: 0.16,
    ease: [0.23, 1, 0.32, 1]
  }} className="fixed inset-0 z-[100] bg-ink/95 backdrop-blur-sm" data-id="element-145" data-mp="1ym2m0iq1r660">
      <motion.div initial={{
      opacity: 0,
      scale: 0.97
    }} animate={{
      opacity: 1,
      scale: 1
    }} exit={{
      opacity: 0,
      scale: 0.97
    }} transition={{
      duration: 0.2,
      ease: [0.23, 1, 0.32, 1]
    }} className="neon-edge absolute inset-2 flex flex-col overflow-hidden rounded-lg border border-cyan-vip/25 bg-ink-800 sm:inset-4 lg:inset-6" data-id="element-146" data-mp="1h5z2f0zkbmt3">
        <div className="flex shrink-0 items-center justify-between gap-3 border-b border-line px-3 py-2.5 sm:px-4" data-id="element-147" data-mp="yaiga8iynh76">
          <div className="flex items-center gap-2.5" data-id="element-148" data-mp="13a4sqfqystex">
            <span className="relative flex h-2 w-2" data-id="element-149" data-mp="2smoz9ti3j2a1">
              <span className="absolute inline-flex h-full w-full rounded-full bg-cyan-vip opacity-60" data-id="element-150" data-mp="2sl47ucr2vzge" />
              <span className="relative inline-flex h-2 w-2 rounded-full bg-cyan-vip" data-id="element-151" data-mp="2xjp646mrs927" />
            </span>
            <span className="font-mono text-[10px] uppercase tracking-[0.18em] text-cyan-vip sm:text-[11px] sm:tracking-[0.2em]" data-id="element-152" data-mp="2r5t4rmkmakpo">
              Terminal · OANDA:XAUUSD
            </span>
          </div>

          <button ref={closeRef} type="button" onClick={onClose} aria-label="Cerrar terminal y volver a la página" className="inline-flex h-9 w-9 items-center justify-center rounded-md border border-white/10 text-white/70 transition-colors duration-150 ease-out hover:border-cyan-vip/50 hover:text-cyan-vip focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-cyan-vip" data-id="element-153" data-mp="2h7vgx06o6pxl">
            <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-154" data-mp="305y91nuil2zm" />
          </button>
        </div>

        <div className="min-h-0 flex-1 bg-ink p-1.5 sm:p-2" data-id="element-155" data-mp="1i27mqubb3mk">
          <TradingViewChart fill interval={interval} data-id="element-156" data-mp="3sun2r1t8q61c" />
        </div>
      </motion.div>
    </motion.div>;
}